import Vue from 'vue';
import VueRouter from 'vue-router';
import RouterPrefetch from 'vue-router-prefetch';
import App from './App';
import router from './router/index';
import store from './store/index';
import BlackDashboard from './plugins/blackDashboard';
import VueMuuri from 'vue-muuri';
import 'vue-muuri/dist/vue-muuri.css';
import i18n from './i18n';
import BootstrapVue from 'bootstrap-vue';
Vue.use(BootstrapVue);
Vue.use(VueMuuri);
Vue.use(BlackDashboard);
Vue.use(VueRouter);
Vue.use(RouterPrefetch);

Vue.directive('click-outside', {
  bind: function (el, binding, vnode) {
    el.clickOutsideEvent = function (event) {
      // here I check that click was outside the el and his children
      if (!(el == event.target || el.contains(event.target))) {
        // and if it did, call method provided in attribute value
        vnode.context[binding.expression](event);
      }
    };
    document.body.addEventListener('click', el.clickOutsideEvent);
  },
  unbind: function (el) {
    document.body.removeEventListener('click', el.clickOutsideEvent);
  },
});

Vue.component('Error', () => import('./components/Common/Error.vue'));
Vue.component('Empty', () => import('./components/Common/Empty.vue'));
Vue.component('ListLoader', () => import('./components/Common/ListLoader.vue'));

Vue.component('ActionButtons', () => import('./components/Common/ActionButtons.vue'));

/* eslint-disable no-new */
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app');
